<article class="rounded-xl border border-slate-200 bg-white p-4 transition hover:border-slate-300 sm:p-5">
    <div class="flex items-center gap-3 sm:gap-4">
        <a [routerLink]="['/users/profile', athlete.id]" class="flex min-w-0 flex-1 items-center gap-3 !text-strong sm:gap-4">
            <img class="h-12 w-12 shrink-0 rounded-lg object-cover sm:h-14 sm:w-14"
                 [src]="athlete.image && athlete.image !== '' ? athlete.image : 'assets/profilePic.png'"
                 [alt]="'Foto di ' + athlete.firstName + ' ' + athlete.lastName"/>
            <span class="flex min-w-0 flex-col gap-1">
                <span class="truncate text-base font-bold leading-tight">{{ athlete.firstName }} {{ athlete.lastName }}</span>
                <span class="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-1">
                    <span class="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md px-2 py-0.5 text-xs font-semibold" [ngClass]="status.classes">
                        <i class="bi" [ngClass]="status.icon" aria-hidden="true"></i>
                        {{ status.label }}
                    </span>
                    <span *ngIf="athlete.email" class="flex min-w-0 items-center gap-1.5 text-xs text-slate-500">
                        <i class="bi bi-envelope shrink-0" aria-hidden="true"></i>
                        <span class="truncate">{{ athlete.email }}</span>
                    </span>
                </span>
            </span>
        </a>

        <a [routerLink]="['/users/profile', athlete.id]"
           class="inline-flex min-h-[40px] shrink-0 items-center gap-1 rounded-lg px-2 text-sm font-semibold !text-slate-600 transition hover:bg-slate-100 hover:!text-primary sm:px-3"
           [attr.aria-label]="'Dettagli di ' + athlete.firstName + ' ' + athlete.lastName">
            <span class="hidden sm:inline">Dettagli</span>
            <i class="bi bi-chevron-right" aria-hidden="true"></i>
        </a>
    </div>

    <!-- Azioni: solo quando c'è qualcosa da fare -->
    <div *ngIf="!athlete.seasonStatus || athlete.seasonStatus === 'pendingPayment' || hasPendingOfflinePayment()"
         class="mt-4 flex flex-wrap items-center gap-2 border-0 border-t border-solid border-slate-100 pt-3">
        <button *ngIf="!athlete.seasonStatus || athlete.seasonStatus === 'pendingPayment'" type="button"
                class="btn btn-primary inline-flex min-h-[40px] items-center justify-center gap-2 !px-4 !py-2 !text-sm"
                (click)="navigateToPayment()" [disabled]="!athleteCompleted()">
            <i class="bi bi-credit-card" aria-hidden="true"></i>
            Iscrizione e pagamento
        </button>

        <a *ngIf="hasPendingOfflinePayment()" [routerLink]="['/iban-details']" [queryParams]="paymentInstructionsQuery"
           class="btn btn-primary inline-flex min-h-[40px] items-center justify-center gap-2 !px-4 !py-2 !text-sm">
            <i class="bi" [ngClass]="paymentInstructionsQuery['ibanSelected'] ? 'bi-bank' : 'bi-geo-alt'" aria-hidden="true"></i>
            {{ paymentInstructionsQuery['ibanSelected'] ? 'Dati per il bonifico' : 'Istruzioni di pagamento' }}
        </a>

        <button *ngIf="hasPendingOfflinePayment()" type="button"
                class="inline-flex min-h-[40px] items-center gap-1.5 rounded-lg border-0 bg-transparent px-2 text-sm font-semibold text-red-600 transition hover:bg-red-50 sm:ml-auto"
                (click)="deletePaymentRequest(athlete.id!)">
            <i class="bi bi-x-circle" aria-hidden="true"></i>
            Annulla richiesta
        </button>
    </div>

    <p *ngIf="(!athlete.seasonStatus || athlete.seasonStatus === 'pendingPayment') && !athleteCompleted()"
       class="mb-0 mt-3 flex items-start gap-2 rounded-lg bg-amber-50 px-3 py-2.5 text-sm leading-5 text-amber-800">
        <i class="bi bi-exclamation-triangle mt-0.5 shrink-0" aria-hidden="true"></i>
        <span>
            Per procedere al pagamento completa tutti i dati dell'atleta.
            <a [routerLink]="['/users/edit-athlete', athlete.id]" class="font-semibold !text-amber-900 underline">Completa ora</a>
        </span>
    </p>
</article>
